export default __webpack_public_path__ + "static/media/profile.b30e8831.svg";